import { styled } from "../../../../styles";

/**
 * Styles for the shared patient detail panel (EN-5169 / EN-5170). Generic
 * admin chrome lives in `shared/AdminPage.styles.ts`; only pieces specific to
 * this panel belong here.
 */

/** Vertical stack of section cards inside one tab. */
export const PanelStack = styled("div", {
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  width: "100%",
});

/** Chip list for the patient's wards, shown beside the record form. */
export const WardChips = styled("div", {
  display: "flex",
  flexWrap: "wrap",
  gap: "6px",
  alignItems: "center",
});

export const WardChip = styled("span", {
  display: "inline-flex",
  alignItems: "center",
  gap: "4px",
  padding: "3px 8px",
  borderRadius: "10px",
  fontSize: "12px",
  fontFamily: "$openSans",
  backgroundColor: "$gray-20",
  color: "$gray-80",
  whiteSpace: "nowrap",

  variants: {
    primary: {
      true: {
        backgroundColor: "$primary-20",
        color: "$primary-80",
        fontWeight: 600,
      },
    },
  },
});

export const SummaryItem = styled("div", {
  display: "flex",
  flexDirection: "column",
  gap: "2px",
});

export const SummaryLabel = styled("dt", {
  margin: 0,
  fontSize: "11px",
  textTransform: "uppercase",
  letterSpacing: "0.04em",
  color: "$gray-70",
  fontFamily: "$openSans",
});

export const SummaryValue = styled("dd", {
  margin: 0,
  fontSize: "14px",
  color: "$charcoal",
  fontFamily: "$openSans",
});

/** The measurement detail modal's value grid. */
export const ValueGrid = styled("dl", {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fill, minmax(180px, 1fr))",
  gap: "12px 20px",
  margin: 0,
});
